import React from 'react'

export interface DividerProps {
  className?: string
  label?: string
  variant?: string
}

const Divider = React.forwardRef<HTMLHRElement, DividerProps>(
  ({ className = '', label, ...rest }, ref) => {
    if (label) {
      return (
        <div className="flex items-center gap-3 w-full">
          <hr className="flex-1 border-silver-light" ref={ref} {...rest} />
          <span className="shrink-0 font-body text-sm text-ink-muted">{label}</span>
          <hr className="flex-1 border-silver-light" />
        </div>
      )
    }

    return <hr className={`border-silver-light ${className}`} ref={ref} {...rest} />
  }
)

Divider.displayName = 'Divider'

export default Divider
